<template>
  <div class="mt-1 mb-3">
    <h3 class="mb-1 text-lg font-bold">{{ $t("settings.devices") }}</h3>
    <div class="flex h-[50px] items-center">
      <p class="w-1/3 text-base">{{ $t("settings.device") }}</p>
      <div class="w-1/3">
        <SSelect v-model="deviceId">
          <SSelectTrigger class="w-full">
            <SSelectValue :placeholder="$t('select.device')" />
          </SSelectTrigger>
          <SSelectContent>
            <SSelectItem
              v-for="dev in devices"
              :key="dev.id || ''"
              :value="dev.id || ''"
            >
              {{ dev.name || "" }}
            </SSelectItem>
          </SSelectContent>
        </SSelect>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import DeviceModule from "@/store/modules/device";
import {
  SSelect,
  SSelectContent,
  SSelectItem,
  SSelectTrigger,
  SSelectValue,
} from "@smeetz/ui-core";
import { CashLocationDeviceType } from "@/constants/cash-location";
import { isCashbookV2Enabled } from "@/utils/helpers/feature-flags";

export default defineComponent({
  name: "DeviceSettings",
  components: {
    SSelect,
    SSelectContent,
    SSelectItem,
    SSelectTrigger,
    SSelectValue,
  },
  setup() {
    const deviceId = ref<number | null>(DeviceModule.deviceId || null);
    const devices = computed(() => {
      const deviceInfo = DeviceModule.deviceInfo;
      const devicesFetched = DeviceModule.devices || [];
      const relevantDevices = isCashbookV2Enabled()
        ? devicesFetched.filter((dev: any) => {
            const dt = dev.cashLocation?.DeviceType;
            return dt == null || dt === CashLocationDeviceType.POS;
          })
        : devicesFetched;
      if (!relevantDevices.length && deviceInfo) {
        return [deviceInfo];
      }
      return relevantDevices;
    });

    DeviceModule.fetchDevices();
    return {
      deviceId,
      devices,
    };
  },
});
</script>
